import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '最新爆料', to: '/category/zuixin-baoliao' },
      { label: '社会热点', to: '/category/shehui-redian' },
      { label: '娱乐八卦', to: '/category/yule-bagua' },
      { label: '行业揭秘', to: '/category/hangye-jiemi' },
      { label: '深度调查', to: '/category/shendu-diaocha' },
      { label: '网友投稿', to: '/category/wangyou-tougao' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系方式', to: '/about#contact' },
      { label: '社区规则', to: '/about' },
      { label: '隐私政策', to: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '新手指南', to: '/about' },
      { label: '常见问题', to: '/#faq' },
      { label: '投诉建议', to: '/about#contact' },
      { label: '内容举报', to: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="container-custom py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-chat-smile-2-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                黑料社区
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              真实内容社区平台，汇聚社会热点、行业揭秘、网友爆料等多元话题，致力于为用户提供安全可靠的内容分享与交流环境。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黑料社区 版权所有 | 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}